module.exports = __webpack_public_path__ + "img/leaderboard.63e2b86e.jpg";